import { z } from 'zod';
import { boardParams, boardRole, endpoint, id, memberRole } from './common';

// Who is on a board and what they may do.

export const boardMember = z.object({
    id: z.string(),
    userId: z.string(),
    role: boardRole,
    kiosk: z.boolean().optional(),
    email: z.string().optional(),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
}).passthrough();
export type BoardMember = z.infer<typeof boardMember>;

export const getBoardMembers = endpoint({
    method: 'GET',
    path: '/boards/:boardId/members',
    params: boardParams,
    response: z.object({ members: z.array(boardMember) }),
});

export const updateMemberRole = endpoint({
    method: 'POST',
    path: '/updateMemberRole',
    body: z.object({ boardId: id, userId: id, role: memberRole, kiosk: z.boolean().optional() }),
    response: z.object({ userId: id, role: memberRole, kiosk: z.boolean().optional() }),
});
